<template>
    <b-modal id="AddTicketModal" modal-class="ticket_modal" centered size="lg" hide-footer hide-header
        hide-header-close no-close-on-backdrop no-close-on-esc @shown="onModalShown" @hidden="onModalHidden" >
           <img
      @click="closeModal"
      class="close_cross"
      src="../../../assets/images/cross.svg"
      alt="cross"
    />
       
        <b-container fluid class="py-3">
             <div class="compose-ticket-wrap compose-ticket">
    <div class="mb-3">
      <h5 class="mb-1">
                <strong>New Ticket</strong>
            </h5>
            <p class="clr-bold-grey">
                Please fill the form below to submit your ticket.
            </p>
    </div>
    <div class="ticket-form">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <div class="row">
            <div class="col-md-12 mb-2">
              <input-text
                label-name="Phone"
                label-for="phone"
                input-class="shadow-none"
                :vmodel.sync="form.phone"
                :rules="{ required: true }"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-2">
              <input-text
                label-name="Subject"
                label-for="subject"
                input-class="shadow-none"
                :vmodel.sync="form.subject"
                :rules="{ required: true }"
              />
            </div>
            <div class="col-md-6 mb-2 category-selectwrapper ">
              <input-single-select
                label="Category"
                :vmodel.sync="form.category_id"
                :options="
                  categories.length ? categories.map((item) => item.id) : []
                "
                :custom-label="
                  categories.length
                    ? (id) => categories.find((item) => item.id == id).name
                    : () => {}
                "
                :rules="{ required: true }"
              />
            </div>
          </div>
          <div class="row">
            <input-quill-editor
              :vmodel.sync="form.message"
              label="Message"
              :rules="{ required: true }"
              placeholder="Add your message here ..."
            />
          </div>
          <div class="row uploadFilewrapper">
            <div class="col-12">
            <input-file-multiple
              label="Upload Document"
              validation-label="document"
              :vmodel.sync="form.issue_document"
              form-group-class="col-md-6 mb-1"
            >
            </input-file-multiple>
             <div class="font-13 d-inline-block  clr-bold-grey upload-file-type"
                    >Allowed file types :
                    jpeg,png,jpg,gif,svg,pdf,xls,xlsx,doc,docx,csv & txt</div
                  >
            </div>
         
          </div>
          <div class="button-wrapper d-flex justify-content-end mt-3 align-items-center gap-3">
                <button type="button" class="btn cancel-btn btn-secondary" @click="closeModal">
                    Cancel
                </button>
                <b-button class="univ-btn" type="submit">
                    Save
                </b-button>
            </div>
         
        </form>
      </ValidationObserver>
    </div>
  </div>
           
          
        </b-container>
    </b-modal>
</template>
<script>

import InputFileMultiple from "@/components/form/InputFileMultiple.vue";
import InputQuillEditor from "@/components/form/InputQuillEditor.vue";
import InputSingleSelect from "@/components/form/InputSingleSelect.vue";
import API from "@/resource/Api";
import EventBus from "@/main";

const FORM = {
  phone: "",
  subject: "",
  category_id: "",
  message: "",
  issue_document: [],
  user_type: "G", //for group dashboard
};
export default {
  name: "AddTicketModal",
  components: { InputSingleSelect, InputQuillEditor, InputFileMultiple },
  data: () => ({
    form: {
      ...FORM,
    },
    categories: [],
    show: true,
  }
),
  methods: {
    onModalShown() {
      this.getCategories();
      this.getUserDetails();
    },
    onModalHidden() {
      this.clearForm();
    },
    closeModal() {
      this.clearForm();
      this.$bvModal.hide("AddTicketModal");
    },
    getCategories() {
      API.get('tickets/categories')
        .then((res) => {
          this.categories = res.data.data;
        })
        .catch(() => {
          this.categories = [];
        });
    },
    submit() {
      let loader = this.$loading.show();
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.form)) {
        formData.append(key, value);
        if (
          key == "issue_document" &&
          this.form.issue_document &&
          this.form.issue_document.length
        ) {
          formData.delete("issue_document");
          for (let i = 0; i < this.form.issue_document.length; i++) {
            formData.append(`${key}[${i}]`, this.form.issue_document[i]);
          }
        }
      }
      API.post('tickets', formData)
        .then((res) => {
          if(res.data.status) {
            EventBus.$emit("load-ticket-list");
            this.$notify(res.data.message, "Success");
          } else {
            this.$notify('Something went wrong!', "Error");
          }
        this.closeModal();
      })
      .catch((err) => {
        this.$notify(err.response?.data?.message || 'An error occurred', "Error");
      })
      .finally(() => {
        loader.hide();
      });
    },
    resetForm() {
      const resetFields = {
        subject: "",
        message: "",
        category_id: "",
        issue_document: null,
      };
      Object.keys(resetFields).forEach((k) => {
        this.form[k] = resetFields[k];
      });
      this.$refs.observer.reset();
    },
    getUserDetails() {
      this.form.phone = this.validatePhone(
        this.$store.getters.groupInfo.group_phone
      );
    },
    validatePhone(chars) {
      return chars.replace(/\D/g, "");
    },
    clearForm() {
      this.form = {...FORM};
    },
  },
};
</script>
<style scoped>
#AddTicketModal  .cancel-btn ,#AddTicketModal  .cancel-btn:focus{
    padding: 10px 20px !important;
    width: fit-content;
    font-size: 14px;
    margin: 0;
    border-radius: 6px;
     color: #fff !important;
    background-color: #6c757d !important;
    border: 0 !important;
    outline: none !important;
    box-shadow: none !important;
}

   
</style>
